import {isBondo} from "./index";

const isInBondo = isBondo()

/**
 * 字段映射工具方法, 只有是bondo才需要转换
 * 新key换成老key
 * @param {Object} source 源对象（后端返回的数据）
 * @param {Object} fieldMap 字段映射规则{老key, 新key}，如 { countryId: 'id' }
 * @returns {Object} 转换后的对象
 */
export function mapFields(source, fieldMap) {
  if(!isInBondo) {
    return source
  }
  if (!source || typeof source !== 'object') {
    return source;
  }

  const result = {};
  for (const [oldKey, newKey] of Object.entries(fieldMap)) {
    // 处理对象嵌套，只有嵌套一层的情况
    if(newKey.includes('.')) {
      const arr = newKey.split(".")
      const objKey = arr[0]
      const objSubKey = arr[1]
      if(source.hasOwnProperty(objKey)) {
        const obj = source[objKey]
        if(obj && obj.hasOwnProperty(objSubKey)) {
          result[oldKey] = obj[objSubKey];
        }
      }
    } else {
      if (source.hasOwnProperty(newKey)) {
        result[oldKey] = source[newKey];
      }
    }
  }
  return result;
}


/**
 * 字段映射工具方法, 只有是bondo才需要转换
 * 新key换成老key
 * @param {Array} sourceList 源对象（后端返回的数据）
 * @param {Object} fieldMap 字段映射规则{老key, 新key}，如 { countryId: 'id' }
 * @returns {Object} 转换后的对象
 */
export function mapFieldsList(sourceList, fieldMap) {
  if(!isInBondo) {
    return sourceList
  }
  if (!sourceList || !(sourceList instanceof Array)) {
    return sourceList;
  }
  return sourceList.map(item => mapFields(item, fieldMap))
}

/**
 * 字段映射工具方法, 只有是bondo才需要转换
 * 老key换成新key
 * @param {Object} source 源对象（后端返回的数据）
 * @param {Object} fieldMap 字段映射规则{老key, 新key}，如 { countryId: 'id' }
 * @returns {Object} 转换后的对象
 */
export function mapFieldsReverse(source, fieldMap) {
  if(!isInBondo) {
    return source
  }
  if (!source || typeof source !== 'object') {
    return {};
  }

  const result = {};
  for (const [oldKey, newKey] of Object.entries(fieldMap)) {
    if (source.hasOwnProperty(oldKey)) {
      result[newKey] = source[oldKey];
    }
  }
  return result;
}

/**
 * 充值方式列表字段映射转换
 * @param sourceList
 */
export function payChannelMapField(sourceList) {
  if(!isInBondo || !sourceList) {
    return sourceList
  }
  const list = []
  sourceList.forEach(item => {
    const newItem = {
      orderNum: item.sort,
      rechargeId: item.payId
    }

    if(item.normMsgList && item.normMsgList.length) {
      newItem.rechargeNormList = item.normMsgList.map(normObj => {
        return mapFields(normObj, NORM_MAP)
      })
    }

    if(item.normMsg) {
      newItem.rechargePayType = mapFields(item.normMsg, PAY_TYPE_MAP)
    }
    list.push(newItem)
  })
  return list
}

/**
 * 微服务接口充值返回参数映射
 */
export function microPayResultMap(payResult) {
  if(payResult && payResult.data && payResult.data.data) {
    payResult.data.data = mapFields(payResult.data.data, PAY_MICRO_RESULT_MAP)
  }
}

/**
 * 国家信息字段映射
 * (老key, 新key)
 * @type {{}}
 */
export const COUNTRY_DETAIL_RESULT_MAP = {
  countryId: 'id',
  coding: 'code',
  logo: 'logo',
  logoRect: 'rectLogo',
  countryNum: 'phoneCode',
}

/**
 * 手机号登录参数字段映射
 * @type
 */
export const PHONE_LOGIN_PARAM_MAP = {
  mobile: 'mobile',
  password: 'pwd',
  dialingCode: 'dialingCode',
}

/**
 * 邮箱登录参数字段映射
 * @type
 */
export const EMAIL_LOGIN_PARAM_MAP = {
  email: 'email',
  password: 'pwd',
}

/**
 * 登录结果字段映射
 * @type {{}}
 */
export const LOGIN_RESULT_MAP = {
  userId: 'userId',
  nickName: 'nickName',
  img: 'imgUrl',
  token: 'tkDetail.apiTk',
  systoken: 'tkDetail.sysTk',
  tokenInvalidTime: 'tkDetail.expireTime',
  country: 'regCountryDetail.uniCode',
}

/**
 * 国家信息字段映射
 * @type {{}}
 */
export const COUNTRY_INFO_MAP = {
  countryId: 'id',
  content: 'name',
  coding: 'code',
  countryNum: 'phoneCode',
  logo: 'logo',
  logoRect: 'rectLogo',
}

/**
 * 获取国家下的充值方式
 * @type {{countryId: string, hidePayName: string}}
 */
export const PAY_CHANNELS_PARAM_MAP = {
  countryId: 'countryId',
  hidePayName: 'hideName'
}

/**
 * 充值规格字段映射
 * @type {{}}
 */
export const NORM_MAP = {
  rechargeId: "payId",
  number: "diamondNum",
  preferences: "rate",
  isActivity: "isPromotion",
  activityId: "promotionId",
  img: "promotionImg",
  reverseImg: "promotionImgAr",
  preferenCount: "promotionCount",
  terminal: "deviceType",
  awardNumber: "awardDiamond",
  newNumber: "newDiamond",
  brazilIosNumber: "iosDiamond",
  rechargeNormId: "payNormId",
  price_China: "priceRmb",
  price_America: "priceUs"
}

/**
 * 充值类型字段映射
 * @type {{id: string, payTypeImg: string, payTypeName: string, payTypeShowName: string, payTypeAgentCode: string, aggregatePay: string, orderNum: string}}
 */
export const PAY_TYPE_MAP = {
  id: "id",
  payTypeImg: "rechargeTypeImg",
  payTypeName: "rechargeTypeName",
  payTypeShowName: "rechargeTypeShowName",
  payTypeAgentCode: "rechargeTypeAgentCode",
  aggregatePay: "threeType",
  orderNum: "sort",
}

/**
 * interface充值接口字段映射
 * @type {{rechargeId: string, countryCode: string, source: string, domainCountry: string}}
 */
export const PAY_INTERFACE_MAP = {
  rechargeId: "payId",
  countryCode: "codes",
  source: "s",
  domainCountry: "dC",
}

/**
 * 充值结果反参
 * @type {{payUrl: string, orderNo: string}}
 */
export const PAT_RESULT_MAP = {
  payUrl: 'payUrl',
  tradeNo: 'threeNo',
}

/**
 * 微服务充值接口参数映射
 * @type {{}}
 */
export const PAY_MICRO_PARAM_MAP = {
  payTypeId: 'pid',
  normId: 'nid',
  countryId: 'cid',
  domainCountry: 'dc',
  from: 'f',
  source: 's',
}

/**
 * 微服务充值接口返回映射
 * @type {{payUrl: string, orderNo: string}}
 */
export const PAY_MICRO_RESULT_MAP = {
  payUrl: 'pu',
  orderNo: 'threeNo',
}



// WEBPACK FOOTER //
// ./src/util/FieldMapUtil.js